import React, { PropsWithChildren } from "react";
import cn from "classnames";
/**
 * The header component of a section, intended to contain details and title of a section.
 */
/**
 * @deprecated
 */
export const SectionHeader: React.FC<PropsWithChildren<{}>> = ({ children }: PropsWithChildren<{}>) => {
  const className = cn("section-header");
  return <div className={className}>{children}</div>;
};
